import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Agrupa label, controle (projetado), dica e mensagem de erro — padrão de formulário PMDF.
 */
@Component({
  selector: 'mg3p-field-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'mg3p-field-group',
    '[class.mg3p-field-group--inline]': 'inline()',
    '[class.mg3p-field-group--error]': '!!error()',
  },
  template: `
    @if (label()) {
      <label [attr.for]="for()" class="mg3p-field-group__label text-pmdf-label">
        {{ label() }}
        @if (required()) {
          <span class="mg3p-field-group__req" aria-hidden="true">*</span>
        }
      </label>
    }
    <div class="mg3p-field-group__control">
      <ng-content />
    </div>
    @if (error()) {
      <p class="mg3p-field-group__error text-pmdf-caption" role="alert">{{ error() }}</p>
    } @else if (hint()) {
      <p class="mg3p-field-group__hint text-pmdf-caption" [id]="hintId()">{{ hint() }}</p>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        width: 100%;
      }
      :host(.mg3p-field-group--inline) {
        width: auto;
        min-width: 10rem;
      }
      .mg3p-field-group__req {
        color: var(--color-pmdf-danger, var(--color-danger));
        margin-left: 0.15rem;
      }
      .mg3p-field-group__error {
        margin: 0;
        color: var(--color-pmdf-danger, var(--color-danger));
      }
      .mg3p-field-group__hint {
        margin: 0;
        color: var(--color-pmdf-text-muted, var(--color-text-secondary));
      }
    `,
  ],
})
export class FieldGroupComponent {
  label = input<string>('');
  for = input<string>('');
  hint = input<string>('');
  hintId = input<string>('');
  error = input<string>('');
  required = input(false);
  inline = input(false);
}
